module.exports = __webpack_public_path__ + "static/media/fb.18c0e38f.svg";